import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: Record<string, LayoutComponent> = {
  "7:1": {
    variant: "blockContainer",
    data: {
      block: {
        type: "video",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-650-1-mode.mp4`,
          controls: false,
          loop: true,
          autoplay: true,
        },
      },
      styles: {
        padding: "1% 13%",
      },
    },
  },
  "7:2": {
    variant: "blockContainer",
    data: {
      block: {
        type: "video",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-650-2-modes.mp4`,
          controls: false,
          loop: true,
          autoplay: true,
        },
      },
      styles: {
        padding: "1% 13%",
      },
    },
  },
  "7:3": {
    variant: "blockContainer",
    data: {
      block: {
        type: "video",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-650-3-modes.mp4`,
          controls: false,
          loop: true,
          autoplay: true,
        },
      },
      styles: {
        padding: "1% 13%",
      },
    },
  },
  "7:4": {
    variant: "blockContainer",
    data: {
      block: {
        type: "video",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-650-4-modes.mp4`,
          controls: false,
          loop: true,
          autoplay: true,
        },
      },
      styles: {
        padding: "1% 13%",
      },
    },
  },
  "7:5": {
    variant: "blockContainer",
    data: {
      block: {
        type: "video",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-650-5-modes.mp4`,
          controls: false,
          loop: true,
          autoplay: true,
        },
      },
      styles: {
        padding: "1% 13%",
      },
    },
  },
  "7:6": {
    variant: "blockContainer",
    data: {
      block: {
        type: "video",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-650-6-modes.mp4`,
          controls: false,
          loop: true,
          autoplay: true,
        },
      },
      styles: {
        padding: "1% 13%",
      },
    },
  },
  "7:7": {
    variant: "blockContainer",
    data: {
      block: {
        type: "video",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-650-7-modes.mp4`,
          controls: false,
          loop: true,
          autoplay: true,
        },
      },
      styles: {
        padding: "1% 13%",
      },
    },
  },
};

export default components;
